export const publishedVersions = $axios => ({
  create: viewId => $axios.$post(`/builder/views/${viewId}/publish`),
});
